// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  padding: 0 20px;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}

.order-item {
  width: 100%;
  border: 1px solid var(--accent-color);
  border-radius: 12px;
  padding: 10px 10px 10px 0;
}
.order-item .img_section {
  min-height: 80px;
  max-height: 120px;
}
.order-item .img_section .img_wrap {
  width: 100%;
  height: 100%;
}
.order-item .img_section .img_wrap:has(.default-img) {
  padding: 18px;
}
.order-item .img_section ion-img {
  object-fit: contain;
  width: 90%;
  height: 90%;
  margin: 0 auto;
}
.order-item ion-col {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.order-item .info-article-section .article-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 10px;
}

.icons_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.edit_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.edit_section ion-button {
  height: 22px;
  width: 22px;
  --padding-end: 5px;
  --padding-start: 5px;
  --padding-bottom: 2px;
  min-height: 22px;
  margin: 0px 4px;
}

.flex-text {
  min-height: 30px;
  padding-bottom: 10px;
}

.center-vertical {
  display: flex;
  align-items: center;
}

.items-block {
  display: flex;
  align-items: center;
  justify-content: right;
}
.items-block .circle-quantity {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.paddig-top {
  padding-top: 10px;
}

.flex-end {
  justify-content: flex-end;
}

.note {
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,WAAA;EAMA,eAAA;AANF;AAEE;EACE,mBAAA;AAAJ;;AAMA;EACE,WAAA;EACA,qCAAA;EACA,mBAAA;EACA,yBAAA;AAHF;AAKE;EACE,gBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,WAAA;EACA,YAAA;AAHN;AAKM;EACE,aAAA;AAHR;AAOI;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AALN;AASE;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAPJ;AAYI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AAVN;;AAeA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAZF;;AAiBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAdF;AAgBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAdJ;;AAkBA;EACE,gBAAA;EACA,oBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;AAfF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhBJ;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,qBAAA;EACA,sBAAA;AAjBF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  display: block;\n  width: 100%;\n\n  &:not(:last-child) {\n    margin-bottom: 10px;\n  }\n\n  padding: 0 20px;\n}\n\n.order-item {\n  width: 100%;\n  border: 1px solid var(--accent-color);\n  border-radius: 12px;\n  padding: 10px 10px 10px 0;\n\n  .img_section {\n    min-height: 80px;\n    max-height: 120px;\n\n    .img_wrap {\n      width: 100%;\n      height: 100%;\n\n      &:has(.default-img) {\n        padding: 18px;\n      }\n    }\n\n    ion-img {\n      object-fit: contain;\n      width: 90%;\n      height: 90%;\n      margin: 0 auto;\n    }\n  }\n\n  ion-col {\n    padding: 0 !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n\n\n  .info-article-section {\n    .article-content {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 0px 10px;\n    }\n  }\n}\n\n.icons_block {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n\n}\n\n.edit_section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n\n  ion-button {\n    height: 22px;\n    width: 22px;\n    --padding-end: 5px;\n    --padding-start: 5px;\n    --padding-bottom: 2px;\n    min-height: 22px;\n    margin: 0px 4px;\n  }\n}\n\n.flex-text {\n  min-height: 30px;\n  padding-bottom: 10px;\n}\n\n.center-vertical {\n  display: flex;\n  align-items: center;\n}\n\n\n.items-block {\n  display: flex;\n  align-items: center;\n  justify-content: right;\n\n  .circle-quantity {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n  }\n}\n\n.paddig-top {\n  padding-top: 10px;\n}\n\n.flex-end {\n  justify-content: flex-end;\n}\n\n.note {\n  font-size: 14px;\n  word-wrap: break-word;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
